import { useForm } from 'react-hook-form';
import useRegister, { Register } from '../../api/hooks/authentication/useRegister';
import { settingsInputs } from '../../consts/inputs';
import { toIcons } from '../../consts/Paths';
import MainContext from '../../context/MainContext';
import useIsMobile from '../../hooks/useIsMobile';
import { getInputs } from '../../utils/getMethods';
import CustomInput from '../inputs/CustomInput';
import { useContext, useEffect, useState } from 'react';
import useLogMessage from '../../hooks/useLogMessage';
import useToggle from '../../hooks/useToggle';
import LogMessage from '../misc/LogMessage';
import { logMsgBgColors } from '../../consts/misc';
import Loader from '../Loader';

const SettingsCreateUserModal = (props: any) => {
    const { token } = useContext(MainContext);
    const { registerResponse, register } = useRegister(token);
    const { isMobile } = useIsMobile();
    const createNewUserForm = useForm();
    const { write } = props.logMessage;
    const [isLoading, setIsLoading] = useState(false);

    const onSubmit = (data: any) => {
        setIsLoading(true);
        /* console.log("calling: create new user form"); */
        register(data);
    };

    /* Setting Messsage */
    useEffect(() => {
        /* console.log(registerResponse, registerResult); */
        if (registerResponse?.ok) {
            write('subject', 'User ');
            write('other_text', 'has been added ');
            write('complement', 'successfully!');
            write('bgColor', logMsgBgColors.correct);
            props.toggler.toggle();
            props.resetList.toggle();
        } else if (registerResponse?.ok === false) {
            write('subject', 'User');
            write('other_text', 'has not been addedd');
            write('complement', 'try again');
            write('bgColor', logMsgBgColors.error);
        }
        setIsLoading(false);
    }, [registerResponse]);
    /*  */

    const inputsArray = getInputs(settingsInputs, ['name', 'email', 'password']);
    const renderInputs = inputsArray.map((input, key) => {
        return (
            <CustomInput
                key={key}
                width={isMobile ? '100%' : 564}
                title={input.title}
                name={input.name}
                type={input.type}
                register={createNewUserForm.register}
                errors={createNewUserForm.formState.errors}
                {...input}
            />
        );
    });

    return (
        <div
            className='modal-wrapper'
            style={{
                height: `100vh`,
            }}
        >
            <div
                className='settings-edit-modal'
                style={{
                    width: isMobile ? '345px' : '',
                }}
            >
                <form onSubmit={createNewUserForm.handleSubmit(onSubmit)}>
                    <div className='settings-edit-modal-content' style={{ margin: isMobile ? '35px 19px 0 21px' : '' }}>
                        <div className='modal-header'>
                            <p className='modal-title'>Add user</p>
                            <div className='Oval' onClick={props.toggler.toggle}>
                                <img src={`${toIcons}/close.svg`} />
                            </div>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '25px',
                                marginTop: '22px',
                            }}
                        >
                            {renderInputs}
                        </div>
                        {isLoading ? (
                            <Loader />
                        ) : (
                            <button
                                style={{
                                    marginTop: '44px',
                                    marginRight: '0',
                                    width: isMobile ? '100%' : '105px',
                                }}
                                className='modal-button'
                                type='submit'
                            >
                                <p className='modal-button-text'>Add</p>
                            </button>
                        )}
                    </div>
                </form>
            </div>
        </div>
    );
};
export default SettingsCreateUserModal;
